import $ = require('jquery');

/**
 * Base Drag & Drop class
 *
 * Just some plumbing work so we don't have to rely on the jquery ui widget factory,
 * but still have some of that functionality
 */
    class DD {
        public element: JQuery;
        /**
         * @param selector, element or jQuery object
         */
        constructor(selector: JQuery|string|HTMLElement) {
            this.element = $(selector);
        }

        //a stripped-down version of the _trigger in jquery ui
        trigger(type: string, ev?: any, data?: {}) {
            let prop: string;
            let orig: Event;

            data = data || {};
            let event = $.Event( ev );
            (<any>event).type = type.toLowerCase();
            // the original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[ 0 ];

            // copy original event properties over to the new event
            orig = event.originalEvent;
            if ( orig ) {
                for ( prop in orig ) {
                    if ( !( prop in event ) ) {
                        (<any>event)[ prop ] = (<any>orig)[ prop ];
                    }
                }
            }

            this.element.trigger( event, data );

            return !event.isDefaultPrevented();
        }

        destroy() {
            this.element = null;
        }
    }

export = DD;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/common/js/dd/DD.ts
 **/